import React from "react";
import TemplateComponent from "../../containers/template_page/template_component/template_component";
import Slider from "react-slick";
import "./c99_cards_image.scss"
import InnerHTML from 'dangerously-set-html-content';

class C99CardsImage extends TemplateComponent {
    constructor(props) {
        super(props);
        this.state = {
        };
    };

    componentRender(data) {

        const sliderSettings = {
            arrows: false,
            dots: false,
            infinite: true,
            speed: 500,
            slidesToShow: 2,
            slidesToScroll: 1,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        arrows: false,
                        dots: false,
                        infinite: true,
                        speed: 500,
                        slidesToShow: 1,
                        slidesToScroll: 1,
                    }
                }
            ]
            // beforeChange: (currIndex, nextIndex) => {
            //     // We cannot change the state, or the rerender won't let the slider component to work properly
            //     this.setState({active: nextIndex});
            // }
        };

        return (
            <div className="multicard-with-image">
                <div className="title">
                    {data.title}
                    <hr />
                </div>
                <div className="subtitle">
                    {data.subtitle}
                </div>
                <div className="two-cards-grid">
                    {data.cards.map((card, index) => {
                        return (
                            <div key={index} className="card-wrapper">
                                <div className="card-image">
                                    <img src={card.image} alt="faculty and research image"/>
                                </div>
                                <div className="card-content">
                                    <InnerHTML html={card.content}/>
                                </div>
                                <div className="card-button">
                                    <button aria-label="Discover">
                                        <a href={card.link_url}>{card.link_title}</a>
                                    </button>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>)
    }
}

export default C99CardsImage;